export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "efbetserbia-themeWrap" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "efbetserbia-themeWrap" */'./LiveThemeImporter'),
  },
};
